import { render } from "./DigitalProductsCommentsWidget.vue.js?vue&type=template&id=f11edc6e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductsCommentsWidget.vue?vue&type=template&id=f11edc6e"
import script from "./DigitalProductsCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductsCommentsWidget.vue?vue&type=script&lang=js"
export * from "./DigitalProductsCommentsWidget.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductsCommentsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/digital-product-details-page/DigitalProductsCommentsWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f11edc6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f11edc6e', __exports__)) {
    api.reload('f11edc6e', __exports__)
  }
  
  module.hot.accept("./DigitalProductsCommentsWidget.vue.js?vue&type=template&id=f11edc6e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductsCommentsWidget.vue?vue&type=template&id=f11edc6e", () => {
    api.rerender('f11edc6e', render)
  })

}


export default __exports__